module.exports = "<span >\r\n    <a ng-if=\"inlineMessage.message.promotionLink\"\r\n       ng-href=\"{{inlineMessage.message.promotionLink}}\" class=\"promo--missed input-error \">\r\n    {{inlineMessage.message.promotionDescription}}\r\n    </a>\r\n    <span class=\"promo--missed input-error\" ng-if=\"!inlineMessage.message.promotionLink\">\r\n         {{inlineMessage.message.promotionDescription}}\r\n    </span>\r\n</span>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/collectionzone/inline-messages/missed-promotion.html
 ** module id = 912
 ** module chunks = 1
 **/